import api from './api';

export default async function getServices(url, pesquisa) {

  const params = typeof pesquisa === 'string'
    ? { pesquisa }
    : (pesquisa || {});

  return api
    .get(url, 
    {
      headers: { 'Content-Type': 'application/json', },
      params//:{pesquisa: pesquisa}
    })
    .then(response => {
      return {type: 'success', data: response.data};
    })
    .catch(error => {
      return {
        type: 'error',
        data: error.response?.data || {
          detail: 'Não foi possível comunicar com o servidor.',
        },
      }
    });
}
